@if (isError) {
<div class="error-dialog-header">
	<div class="error-dialog-heading">{{ 'review-messages' | translate }}</div>
	<button type="button" class="error-dialog-close" aria-label="Close validation messages" (click)="cancel()">
		<img src="assets/images/banner/red-close-icon.png" alt="" aria-hidden="true">
	</button>
</div>
} @else {
<div class="dialog-header" mat-dialog-title>
	<div class="header-spacer"></div>
	<div class="header-label">
		@if (data.cssClass == 'msg-warning') {
			<span>[WARNING]</span>
		}
	</div>
	<div class="header-close" fxLayoutAlign="end center">
		<img src="assets/images/banner/red-close-icon.png" alt="Close icon" class="close-btn" (click)="cancel()"
			(keydown.enter)="cancel()">
	</div>
</div>
}

<mat-dialog-content class="messageContainer"
	[class.msg-error]="isError"
	[class.msg-warning]="data.cssClass == 'msg-warning'"
	[class.msg-success]="data.cssClass == 'msg-success'">
	@if (isError) {
	<section class="error-summary" role="alert" aria-live="assertive">
		<div class="error-summary__panel">
			<ul class="error-summary__items">
				@for (msg of displayMessages; track msg.content) {
				<li class="error-summary__item" tabindex="0" (click)="copyMsg(msg)" (keydown.enter)="copyMsg(msg)">
					<div class="error-summary__message" [innerHTML]="msg.content"></div>
				</li>
				}
			</ul>
		</div>
	</section>
	} @else {
	<div class="message-layout">
		<div class="message-body">
			@if (displayMessages.length === 1) {
			<div class="confirmation-content" [innerHTML]="displayMessages[0].content" (click)="copyMsg(displayMessages[0])"
				(keydown.enter)="copyMsg(displayMessages[0])"></div>
			} @else {
			<ul class="message-items">
				@for (msg of displayMessages; track msg.content) {
				<li class="message-item" (click)="copyMsg(msg)" (keydown.enter)="copyMsg(msg)">
					<div class="message-text" [innerHTML]="msg.content"></div>
				</li>
				}
			</ul>
			}
		</div>
	</div>
	}
</mat-dialog-content>

@if (!isError && (data.confirmText || data.cancelText)) {
<mat-dialog-actions class="msg-banner-actions">
	@if (data.confirmText) {
	<button mat-raised-button color="primary" (click)="confirm()">
		{{ data.confirmText }}
	</button>
	}
	@if (data.cancelText) {
	<button mat-stroked-button class="btn-outline-accent btn-clear-sort form-btn" (click)="cancel()">
		{{ data.cancelText }}
	</button>
	}
</mat-dialog-actions>
}
